import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import { routes } from "../../../utlis/admin/routes.utlis";
import ApiService from "../../../core/services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import { Modal, ModalBody } from "react-bootstrap";
import { totalPageCalculator, LIMIT } from "../../../utlis/common.utlis";
import { encode } from "base-64";
import toast from "react-hot-toast";

const Page = () => {
  const navigate = useNavigate();
  const [select, setSelect] = useState({
    id: null,
    lat: null,
    lng: null,
    cate: null,
  });
  const [send, setSend] = useState({
    status: false,
    lat: null,
    lng: null,
    cate: null,
  });
  const [categories, setCategory] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    categoryid: "",
    startDate: null,
    endDate: null,
    month: "",
    quarter: "",
    year: "",
  });
  const [dateType, setDateType] = useState("");

  const getAssessmentList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      const assessmentData = [];
      for (const key in response.data.data.homeCareAssessmentList) {
        response.data.data.homeCareAssessmentList[key].checked = false;
        const itemData = response.data.data.homeCareAssessmentList[key];
        assessmentData.push(itemData);
      }
      setAssessment(assessmentData);
      setTotal(response.data.data.total);
      setLoading(false);
    } else setAssessment([]);
    setLoading(false);
  };

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  /* const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    let categoryid = "";
    if (e.target.name === "name") name = e.target.value;
    if (e.target.name === "categoryid") categoryid = e.target.value;
    if (date !== null && date !== undefined && date !== "")
      date = moment(date).format("yyyy-MM-DD");
    else date = "";
    getAssessmentList(
      api.assessmentList +
      `?page=${pageNum}&limit=${LIMIT}&search=${name}&date=${date}&categoryid=${categoryid}`
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAssessmentList(api.assessmentList + `?page=${pageNum}&limit=${LIMIT}`);
    getCategoryList(api.categoryList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]); */

  const handleDateTypeChange = (e) => {
    const value = e.target.value;

    // Clear all other date-related fields when selecting a new date_type
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: null,
      endDate: null,
      month: value === "month" ? prevFilters.month : "",
      quarter: value === "quarter" ? prevFilters.quarter : "",
      year: value === "year" || value === "month" || value === "quarter" ? prevFilters.year : "",
    }));

    setDateType(value);
  };

  const handleFilterChange = (e, date = null) => {
    const { name, value } = e.target || {};
    const formattedDate = date ? moment(date).format("yyyy-MM-DD") : null;

    console.log("Input Name:", name); // Debugging
    console.log("Input Value:", value); // Debugging
    console.log("Formatted Date:", formattedDate); // Debugging

    // Update the filters state
    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [name]: date === null ? value : formattedDate, // Use `value` for non-date fields, `formattedDate` for date fields
      };

      console.log("Updated Filters:", updatedFilters); // Debugging

      // Fetch filtered data with updated filters
      fetchFilteredData(updatedFilters);

      return updatedFilters;
    });

    // Reset to the first page when filters change
    setPageNum(1);
  };

  const fetchFilteredData = async (filterParams) => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      search: filterParams.name,
      categoryid: filterParams.categoryid,
      startDate: filterParams.startDate,
      endDate: filterParams.endDate,
      month: filterParams.month,
      quarter: filterParams.quarter,
      year: filterParams.year,
    }).toString();

    console.log("Query String:", query); // Debugging

    // Call the API with the constructed query
    getAssessmentList(`${api.assessmentList}?${query}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const query = new URLSearchParams({
        page: pageNum,
        limit: LIMIT,
        search: filters.name,
        categoryid: filters.categoryid,
        startDate: filters.startDate,
        endDate: filters.endDate,
        month: filters.month,
        quarter: filters.quarter,
        year: filters.year,
      }).toString();

      console.log("Filters in useEffect:", filters); // Debugging  

      getAssessmentList(`${api.assessmentList}?${query}`);
      getCategoryList(api.categoryList);
    };

    fetchData();

  }, [filters, pageNum]); // Dependencies: filters and pageNum



  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h2 className="heading-title">Care Assessment</h2>
          <div className="cc-search-filter wd50">
            <div className="row g-2">
              <div className="col-md-3">

              </div>
              <div className="col-md-9">
                <div className="form-group">
                  <button
                    type="button"
                    className="btn-bl w-100"
                    onClick={() => {
                      select.id !== null &&
                        select.id !== "" &&
                        select.id !== undefined
                        ? setSend({
                          status: true,
                          lat: select.lat,
                          lng: select.lng,
                          cate: select.cate,
                        })
                        : toast.error("Select any care job first");
                    }}
                  >
                    Send Request To Care Providers & Staff
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="care-title-header">
          <div className="cc-search-filter wd100">
            <div className="row g-2">
              <div className="col-md-3">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Search by User Name"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleFilterChange}
                  />
                  <span className="search-icon">
                    <i className="cc-input-group-text  mdi mdi-magnify"></i>
                  </span>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group dropdown-select">
                  <select
                    className="form-control"
                    name="categoryid"
                    onChange={handleFilterChange}
                  >
                    <option value="">Select Category</option>
                    {categories.length !== 0
                      ? categories.map((ele, indx) => {
                        return (
                          <option key={indx} value={ele.id}>
                            {ele.name ?? "NA"}
                          </option>
                        );
                      })
                      : null}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="date_type"
                    onChange={handleDateTypeChange}
                  >
                    <option value="">Choose Date Range</option>
                    <option value="date">Date</option>
                    <option value="month">Month</option>
                    <option value="quarter">Quarter</option>
                    <option value="year">Year</option>
                  </select>
                </div>
              </div>

              {/* Conditionally Render Fields Based on Date Type */}
              {dateType === "date" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      {/* From Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.startDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "startDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="From Date"
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      {/* To Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.endDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "endDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="To Date"
                      />
                    </div>
                  </div>
                </>
              )}

              {dateType === "month" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="month"
                        onChange={handleFilterChange}
                      >
                        <option value="">Select Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={handleFilterChange}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "quarter" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="quarter"
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">All Quarters</option>
                        <option value="1">Q1 (Jan - Mar)</option>
                        <option value="2">Q2 (Apr - Jun)</option>
                        <option value="3">Q3 (Jul - Sep)</option>
                        <option value="4">Q4 (Oct - Dec)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "year" && (
                <div className="col-md-2">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="year"
                      onChange={(e) => handleFilterChange(e)}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
        <div className="cc-table-card">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Email ID</th>
                  <th>Phone Number</th>
                  <th>Address</th>
                  <th>Start Date</th>
                  <th>View Detail</th>
                </tr>
              </thead>
              <tbody>
                {assessment.length !== 0 ? (
                  assessment.map((ele, indx) => {
                    return (
                      <tr key={indx}>
                        <td>
                          <input
                            className="form-check-input"
                            type="radio"
                            name="select"
                            onChange={() =>
                              setSelect({
                                id: ele.id,
                                lat: ele.latitude,
                                lng: ele.longitude,
                                cate: ele.subcategory_id,
                              })
                            }
                          />
                        </td>
                        <td className="text-capitalize">
                          {" "}
                          {ele.first_name ?? "NA"}{" "}
                        </td>
                        <td className="text-lowercase">
                          {" "}
                          {ele.email_id ?? "NA"}{" "}
                        </td>
                        <td> {ele.phone ?? "NA"} </td>
                        <td> {ele.address ?? "NA"} </td>
                        <td> {ele.start_date ?? "NA"} </td>
                        <td>
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.careAssessmentDetail, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <label
                              style={{ cursor: "pointer" }}
                              className="badge badge-gradient-success"
                            >
                              <i className="fa fa-eye"></i>
                            </label>
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="text-center">
                    <td colSpan="6">
                      <div>
                        <p>No assessment found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex align-items-center justify-content-center mt-3">
              {assessment.length !== 0 ? (
                <div className="care-table-pagination">
                  <ul className="care-pagination">
                    {pageNum !== 1 && (
                      <li
                        className="disabled"
                        id="example_previous"
                        onClick={() => setPageNum(pageNum - 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          Previous
                        </Link>
                      </li>
                    )}

                    {totalPageCalculator(total, LIMIT).length === 1
                      ? null
                      : totalPageCalculator(total, LIMIT).map(
                        (pageNo, indx) => {
                          return (
                            <li
                              className={pageNo === pageNum ? "active" : ""}
                              key={indx}
                              onClick={() => setPageNum(pageNo)}
                            >
                              <Link to="" className="page-link">
                                {pageNo}
                              </Link>
                            </li>
                          );
                        }
                      )}

                    {pageNum !== Math.ceil(total / LIMIT) && (
                      <li
                        className="next"
                        id="example_next"
                        onClick={() => setPageNum(pageNum + 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="7"
                          tabIndex="0"
                          className="page-link"
                        >
                          Next
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={send.status}
        onHide={() => {
          setSend({
            status: false,
            lat: null,
            lng: null,
            cate: null,
          });
          setSelect({
            id: null,
            lat: null,
            lng: null,
            cate: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Send Request</h5>
                <p className="text-center">
                  Do you want to proceed with sending this request to the care
                  provider ?
                </p>
              </div>
              <div className="form-group text-center">
                <button
                  type="button"
                  onClick={() => {
                    setSend({
                      status: false,
                      lat: null,
                      lng: null,
                      cate: null,
                    });
                    setSelect({
                      id: null,
                      lat: null,
                      lng: null,
                      cate: null,
                    });
                  }}
                  className="btn-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-gr me-2"
                  data-bs-dismiss="modal"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes.moreProvider, {
                      state: {
                        lat: send?.lat,
                        lng: send?.lng,
                        cateId: send?.cate,
                        id: encode(select?.id),
                      },
                    });
                  }}
                >
                  Yes! Proceed
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
